<script>
import { mapActions, mapGetters } from 'vuex';
import { uniq } from 'lodash';
import CardListItem from './cards-list-item';

import { compareDesc, parseISO } from 'date-fns';

export default {
  name: 'CommandesEnCours',
  components: {
    CardListItem
  },
  data: () => ({
    loading: true,
    commandeSelectionnee: null,
    optionsTri: [{ value: 0, text: 'Etape' }, { value: 1, text: 'Date' }],
    optionTri: 0,
    loadingHistorique: false,
    endHistorique: false

  }),
  computed: {
    ...mapGetters({ tiers: 'user/tiers', commandesEnCours: 'commandes/commandesEnCours', historiqueCommandes: 'commandes/historiqueCommandes' }),

    commandesEnCoursSorted () {
      return this.commandesEnCours
        .slice()
        .sort((a, b) => {
          if (this.optionTri === 0) {
            const aa = (this.getOrdreEtape(a.etape));
            const bb = (this.getOrdreEtape(b.etape));
            if (aa !== bb) {
              return aa - bb;
            }
          }
          return compareDesc(parseISO(a.date), parseISO(b.date));
        });
    }

  },
  created () {
    Promise.all([
      this.loadcommandesEnCours(this.tiers.numTiers),
      this.loadHistoriqueCommandes(this.tiers.numTiers)
    ]).then(() => {
      this.loading = false;
    });
  },
  methods: {
    ...mapActions({ loadcommandesEnCours: 'commandes/loadCommandesEnCours', loadHistoriqueCommandes: 'commandes/loadHistoriqueCommandes', loasSuiteHistoriqueCommandes: 'commandes/loadSuiteHistoriqueCommandes' }),

    detailLigne (commande) {
      this.commandeSelectionnee = commande;
    },
    retourEntete () {
      this.commandeSelectionnee = null;
    },

    getStatutCommande (commande) {
      const statutsLignes = uniq(commande.lignes.map(l => l.etape));
      if (statutsLignes.length > 1) {
        return 'Voir détails, plusieurs étapes';
      } else {
        return this.getLibelleStatut(commande.etape);
      }
    },

    getLibelleStatut (etape) {
      switch (etape) {
        case 'ENREGISTREE':
          return 'En attente de validation';
        case 'PREPAREE':
          return 'EN LOGISTIQUE';
        default:
          return etape;
      }
    },

    getOrdreEtape (etape) {
      switch (etape) {
        case 'En attente de validation':
          return 1;
        case 'VALORISEE':
          return 2;
        case 'PREPAREE':
          return 3;
        case 'EN LOGISTIQUE':
          return 3;
        case 'LIVREE':
          return 4;
        case 'FACTUREE':
          return 5;

        case 'SUPPRIMEE':
          return 9;
      }
      return null;
    },
    historiqueAfficherPlus () {
      this.loadingHistorique = true;
      this.loasSuiteHistoriqueCommandes(this.tiers.numTiers).then((response) => {
        this.loadingHistorique = false;
        if (response.length === 0) {
          this.endHistorique = true;
        }
      });
    }
  }
};
</script>

<template>
  <Loader v-if="loading" />

  <div
    v-else
    class="content"
  >
    <div v-if="!commandeSelectionnee">
      <h1 class="primary--text mb-6">
        Commandes internet
        <CardsHelp
          :page="'COMMANDE'"
          :niveau="'TITRE'"
        />
      </h1>

      <div v-if="!isMobile">
        <h2>Commandes en cours</h2>
        <div class="tri">
          Tier par :
          <v-select
            v-model="optionTri"
            :items="optionsTri"
            hide-details
          />
        </div>
        <table

          class="list-lots"
        >
          <thead>
            <tr>
              <th class="header">
                Commandes
              </th>
              <th class="header">
                Date de commande
              </th>

              <th class="header">
                Etape
              </th>

              <th />
            </tr>
          </thead>

          <tbody>
            <tr
              v-for="commande in commandesEnCoursSorted"
              :key="commande.id"
              @click="detailLigne(commande)"
            >
              <td>
                Commande {{ commande.numero }}
              </td>
              <td>
                du {{ commande.date | date }}
              </td>

              <td class="secondary--text s-etape">
                {{ getStatutCommande(commande) }}
              </td>
              <td>
                <v-icon
                  class="ml-5"
                  color="indigo"
                  @click="detailLigne(commande)"
                >
                  mdi-chevron-right-circle-outline
                </v-icon>
              </td>
            </tr>
          </tbody>
        </table>
        <h2>Historique des commandes</h2>
        <table

          class="list-lots"
        >
          <thead>
            <tr>
              <th class="header">
                Commandes
              </th>
              <th class="header">
                Date de commande
              </th>

              <th class="header">
                Etape
              </th>

              <th />
            </tr>
          </thead>

          <tbody>
            <tr
              v-for="commande in historiqueCommandes"
              :key="commande.id"
              @click="detailLigne(commande)"
            >
              <td>
                Commande {{ commande.numero }}
              </td>
              <td>
                du {{ commande.date | date }}
              </td>

              <td class="secondary--text s-etape">
                {{ getStatutCommande(commande) }}
              </td>
              <td>
                <v-icon
                  class="ml-5"
                  color="indigo"
                  @click="detailLigne(commande)"
                >
                  mdi-chevron-right-circle-outline
                </v-icon>
              </td>
            </tr>
          </tbody>
        </table>
        <div style="text-align:center;">
          <v-btn
            :loading="loadingHistorique"
            :disabled="endHistorique"
            @click="historiqueAfficherPlus"
          >
            Afficher plus de commandes
          </v-btn>
        </div>
      </div>
      <div
        v-if="isMobile"
        class="liste-lots-mobile"
      >
        <h2>Commandes en cours</h2>
        <div class="tri">
          Tier par :
          <v-select
            v-model="optionTri"
            :items="optionsTri"
            hide-details
          />
        </div>
        <v-card
          v-for="commande in commandesEnCoursSorted"
          :key="commande.id"
          class="card-cmd"
          @click="detailLigne(commande)"
        >
          <v-card-title>
            <div class="line">
              Commande : {{ commande.numero }} du {{ commande.date | date }}
            </div>
          </v-card-title>
          <v-card-text>
            <div class="header">
              {{ getStatutCommande(commande) }}
              <v-icon
                class="ml-5"
                color="indigo"
                @click="detailLigne(commande)"
              >
                mdi-chevron-right-circle-outline
              </v-icon>
            </div>
          </v-card-text>
        </v-card>
        <h2>Historique des commandes</h2>
        <v-card
          v-for="commande in historiqueCommandes"
          :key="commande.id"
          class="card-cmd"
          @click="detailLigne(commande)"
        >
          <v-card-title>
            <div class="line">
              Commande : {{ commande.numero }} du {{ commande.date | date }}
            </div>
          </v-card-title>
          <v-card-text>
            <div class="header">
              {{ getStatutCommande(commande) }}
              <v-icon
                class="ml-5"
                color="indigo"
                @click="detailLigne(commande)"
              >
                mdi-chevron-right-circle-outline
              </v-icon>
            </div>
          </v-card-text>
        </v-card>
        <v-btn
          :loading="loadingHistorique"
          :disabled="endHistorique"
          block
          @click="historiqueAfficherPlus"
        >
          Afficher plus de commandes
        </v-btn>
      </div>
    </div>
    <div v-else>
      <h1 class="primary--text mb-6">
        Détails de la commande <strong>{{ commandeSelectionnee.numero }}</strong> du {{ commandeSelectionnee.date | date }}
      </h1>
      <v-btn
        class="btn-liste"
        color="grey"
        outlined
        @click="retourEntete()"
      >
        <v-icon>mdi-arrow-left</v-icon>
        Liste des commandes
      </v-btn>
      <br>
      <br>

      <CardsList
        :items="commandeSelectionnee.lignes"
        column-size="100%"
      >
        <template v-slot:empty>
          Aucun aliment.
        </template>

        <template v-slot:item="{item}">
          <CardListItem :item="item" />
        </template>
      </CardsList>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.tri {
  .v-select {
    display: inline-block;
  }
}
.list-lots {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0 1em;
  .header {
    padding: 0 1.5em;
  }

  tbody {
    tr {
      box-shadow: 3px 3px 10px lightgrey;
      cursor: pointer;
    }
    td {
      padding: 0.5em 1.5em;
      background-color: white;
      background-clip: padding-box;
    }
  }

  .pad-top td {
    border-top: 2em solid transparent;
  }
}

.line {
  font-weight: 500;
  font-size: 14px;
}

.header {
  text-align: left;
  font-weight: normal;
  color: var(--v-secondary-base);
}

.content {
  margin: 3vw;
  padding: 2vw;
  background-color: #f4f8f9;
}

.s-etape {
  text-transform: lowercase;
  &::first-letter {
    text-transform: capitalize;
  }
}

.card-cmd {
  margin-bottom: 2vw;
}

.btn-liste {
  margin-bottom: 1vw;
}

@import "~vuetify/src/styles/settings/_variables";
@media #{map-get($display-breakpoints, 'xs-only')} {
  .content {
    margin: 0;
    padding: 3vw;
  }
}
</style>
